import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import ReactHighcharts from 'react-highcharts';
import {injectIntl} from 'react-intl';
import getTranslatedText from '../../services/getTranslatedText';

const styles = {
  wrapper: {
    padding: 15
  },
};

class ScoreByAnswerToOtherQuestionBarChart extends Component {
  render() {
    const intl = this.props.intl;
    const answersReport = this.props.answersReport;
    const scoreByAnswerToOtherQuestion = answersReport ? answersReport.scoreByAnswerToOtherQuestion : [];

    const categories = scoreByAnswerToOtherQuestion.map(item => getTranslatedText(item.text, intl.locale));
    const data = scoreByAnswerToOtherQuestion.map(item => item.score);

    const chartConfig = {
      chart: {
        type: 'bar',
        height: this.props.height-(styles.wrapper.padding*2),
        width: this.props.width-(styles.wrapper.padding*2),
      },
      title: {
        text: intl.formatMessage({id: 'scoreByAnswerToOtherQuestion'}),
        margin: 5,
        style: {
          fontSize: '14px',
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        formatter: function() {
          const index = categories.findIndex(x => x === this.x);
          return intl.formatMessage({
            id: 'numberOfAnswers',
          },{
            count: scoreByAnswerToOtherQuestion[index].count,
          });
        },
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: false,
      },
      plotOptions: {
        bar: {
          dataLabels: {
            enabled: true,
            format: '{y:.1f}',
          },
          pointPadding: 0,
          groupPadding: 0.1,
        },
      },
      series: [{
        data,
      }],
    };
    return (
      <div style={styles.wrapper}>
        <ReactHighcharts
          config={chartConfig}
          domProps={{id: this.props.uniqueId}}
        />
      </div>
    );
  }
}

export default createFragmentContainer(
  injectIntl(ScoreByAnswerToOtherQuestionBarChart),
  graphql`
    fragment ScoreByAnswerToOtherQuestionBarChart_answersReport on AnswersReport {
      scoreByAnswerToOtherQuestion(
        otherQuestionMongoId: $otherQuestionMongoId
      ) {
        text {
          language
          text
        }
        score
        count
      }
    }
  `,
);



// WEBPACK FOOTER //
// ./src/components/ScoreByAnswerToOtherQuestionBarChart/ScoreByAnswerToOtherQuestionBarChart.js